<template>
    <div :class="view_class_view.div_content_button">
        <div v-html="printMatiButton()"></div>
    </div>
</template>

<script>
import { ref, toRef, onMounted } from 'vue';

export default {
    name: 'IdentityVerificationComponent',
    props: {
        matiClientId: {
            type: String,
            default(){
                return "";
            }
        },
        matiClientSecretId: {
            type: String,
            default(){
                return "";
            }
        },
        matiuserid: {
            type: String,
            default(){
                return "";
            }
        },
        admissionId: {
            type: String,
            default(){
                return "";
            }
        },
        view_class_view: {
            type: String,
            default(){
                return "";
            }
        },
        business: {
            type: String,
            default(){
                return "";
            }
        },
        tableType: {
            type: String,
            default(){
                return "";
            }
        }
    },
    setup(props, { emit }){

        let matiIdentityId = ref(null);
        let matiVerificationTableType = toRef(props, "tableType");
        let business = toRef(props, "business");
        let matiFlowid = toRef(props, 'matiuserid');
        let matiClientId = toRef(props, 'matiClientId');
        let admissionId = toRef(props, 'admissionId');

        onMounted(()=>{
            matiButton();
        });

        const matiButton = () => {
            if(document.getElementById("btnMati") != null){
                
                if(matiIdentityId.value == null || matiIdentityId.value == "") {
                    document.getElementById("btnMati").addEventListener("mati:userFinishedSdk", ({detail}) => {
                        
                        localStorage.setItem("matiIdentityId", detail.identityId);
                        matiIdentityId.value = localStorage.matiIdentityId;

                        let matiDetail = {
                            mati_identity_id: matiIdentityId.value,
                            table_type: matiVerificationTableType.value,
                            business: business.value,
                            detail: detail
                        };

                        // console.log("finisheduserFinishedSdk META", detail);
                        // console.log("matiIdentityId: META", matiIdentityId.value);

                        emit("verification_identity", matiDetail);
                    });
                }
            }
        }

        function printMatiButton(){
            return `<mati-button id="btnMati" clientid="${matiClientId.value}" metadata='{"business_acronym": "${business.value}", "mati_verification_type": "${matiVerificationTableType.value}", "mati_verification_id": "${admissionId.value}"}' flowId="${matiFlowid.value}" />`
        }

        return {
            matiButton,
            matiVerificationTableType,
            matiFlowid,
            printMatiButton
        }
    }
}
</script>